/*
 * ////////////////////////////////////////////////////////////////////////////////
 * //
 * // This software system consists of computer software and documentation.
 * // It contains trade secrets and confidential information which are proprietary
 * // to Everi Games Inc.  Its use or disclosure in whole or in part without
 * // the express written permission of Everi Games Inc. is prohibited.
 * //
 * // This software system is also an unpublished work protected under the copyright
 * // laws of the United States of America.
 * //
 * // Copyright © 2018 Everi Games Inc.  All Rights Reserved
 * //
 * ////////////////////////////////////////////////////////////////////////////////
 */
import ReferencedComponent from '../ComponentReference/ReferencedComponent';

/** @hidden */
// tslint:disable-next-line:typedef
const property = cc._decorator.property;

/** Basic component for triggering a scripted action on a specific event. */
@cc._decorator.ccclass
export default abstract class ActionComponentBase extends ReferencedComponent
{
    /** Implement the desired scripted action here. */
    protected abstract action: (args?: any) => any;

    /** Register any needed event listeners here. */
    protected abstract configureListeners(): void;

    /** Unregister any event listeners registered in the configureListeners() method. */
    protected abstract destroyListeners(): void;

    /** @hidden */
    protected onLoad(): void
    {
        super.onLoad();
    }

    /** @hidden */
    protected start(): void
    {
        super.start();

        this.configureListeners();
    }

    /** @hidden */
    protected onDestroy(): void
    {
        this.destroyListeners();
        super.onDestroy();
    }
}
